import { render } from "./SurveyAdminDashboard.vue?vue&type=template&id=19ae854d"
import script from "./SurveyAdminDashboard.vue?vue&type=script&lang=js"
export * from "./SurveyAdminDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__